import { createContext } from 'react';

const Context = createContext<string>('');
Context.displayName = 'persistence context';

export default Context;
